import styled from "styled-components";

export const ContentCard = styled.div`
  padding: 1.25rem;
  background: #FFFFFF;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.25);
  width: 100%;
`;